import api from './api';
import jwt from 'jsonwebtoken';
import encodeURL from '../helpers/encodeURL';

export function verifyActiveSession(keycloak) {
  let session = localStorage.getItem('@EC-session');

  if(!session) {
    if(keycloak.authenticated) {
      const { token, refreshToken, clientId } = keycloak;
      const decoded = jwt.decode(token);
      
      const { 
        email,
        name,
        family_name,
        given_name,
        id_portalcomercial,
        idAsesor,
        CodigoAsesor,
        preferred_username: username,
        azp: name_portalcomercial,
        resource_access: recursos
      } = decoded;

      const {[name_portalcomercial]: user_roles} = recursos;
      const { roles } = user_roles;
      const rol = roles.filter(x => x.includes('rol'))[0];//'rol_asesor_comercial'
      session = JSON.stringify({
        token,
        refreshToken,
        email,
        name,
        idAsesor,
        CodigoAsesor,
        family_name,
        given_name,
        id_portalcomercial,
        clientId,
        username,
        rol
      });

      localStorage.setItem('@EC-session', session);

      return true;
    }
  }

  return false;
}

export function checkExpiresToken(keycloak) {
    let session = JSON.parse(localStorage.getItem('@EC-session'));
    const decoded = jwt.decode(session.token);
    
    if (Date.now() <= decoded.exp * 1000) {
      return false;
    } else {
      logout(keycloak);
      return true;
    }
}

export async function refreshToken(client_id, grant_type, token) {
  try {
    let session = JSON.parse(localStorage.getItem('@EC-session'));

    const data = {
      client_id: client_id,
      grant_type: grant_type,
      refresh_token: token
    }

    const response = await api.post('auth/realms/rei_excelcredit/protocol/openid-connect/token/', encodeURL(data));

    session = {
      ...session,
      refreshToken: response.data.refresh_token,
      token: response.data.id_token
    }

    localStorage.setItem('@EC-session', JSON.stringify(session));
  } catch (error) {
    console.log(error.response)
  }
}

export function logout(keycloak) {
  localStorage.removeItem('@EC-session');
  keycloak.logout();
}
